import { actions } from '.';

export function fetchAccountSucceed(payload) {
  return {
    type: actions.GET_ACCOUNT_SUCCEED,
    payload
  };
}
export function fetchAccountFailure(payload) {
  return {
    type: actions.GET_ACCOUNT_FAILURE,
    payload
  };
}

export function fetchAccountsSucceed(payload) {
  return {
    type: actions.GET_ACCOUNTS_SUCCEED,
    payload
  };
}

export function sendAccountInvitationSucceed(payload) {
  return {
    type: actions.SEND_ACCOUNT_INVITATION_SUCCEED,
    payload
  };
}

export function sendAccountInvitationFailure(payload) {
  return {
    type: actions.SEND_ACCOUNT_INVITATION_FAILURE,
    payload
  };
}

export function destroyAccountSucceed(payload) {
  return {
    type: actions.DESTROY_ACCOUNT_SUCCEED,
    payload
  };
}

export function updateAccountSucceed(account) {
  return {
    type: actions.UPDATE_ACCOUNT_SUCCEED,
    payload: account
  };
}
